export default __webpack_public_path__ + "static/media/CreatePatient.db0ad735.svg";